import { Card } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrderProductSelect from '../OrderProduct/OrderProductSelect';
import TableProductSelected from '../OrderProduct/TableProductSelected';
import { useRestContext } from 'components/form/RestInputContext';
import _ from 'lodash';
import { DynamicObjectType } from 'types/commons';
import { RETURN_STATUS } from 'constants/ordersReturn';
import { getDataDetail } from 'utils/tools';

interface ProductsCardTypes {
  isEdit?: boolean;
  isLayoutEditProducts?: boolean;
}

function ProductsCard({ isEdit, isLayoutEditProducts }: ProductsCardTypes) {
  const { t } = useTranslation();
  const { form, record } = useRestContext();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const variantsSelectionModalRef = useRef<any>();

  const [productsInOrder, setProductsInOrder] = useState([]);

  const openVariantSelectionModal = (id) => {
    variantsSelectionModalRef.current.open(id);
  };

  const handleGetProducts = (products) => {
    setProductsInOrder(products);
  };

  const checkIsGift = (item, price) => {
    return item?.isGift ? 0 : price || 0;
  };

  const handleConvertData = (data) => {
    if (!(Array.isArray(data) && data?.length > 0)) return [];

    return _.flatten(
      data.map((item) => {
        if (item?.quantity <= 1) {
          return {
            ...item,
            // name: getDataDetail(item, 'detail', 'name', null)?.name,
            name: item?.productName || item?.name,
            discountPrice: checkIsGift(item, item?.discountPrice),
            erpAmount: checkIsGift(item, item?.erpAmount),
            // originalPrice:  item?.originalPrice || 0,
            originalPrice: checkIsGift(item, item?.variant?.originalPrice),
            quantity: 1,
            variantText:
              item?.variantText ||
              item?.variant?.attributeValues
                ?.map((item) => getDataDetail(item)?.name)
                ?.join('/') ||
              record?.order?.items?.find((e) => e?.id === item?.id)
                ?.variantText,
            sku: item?.sku || item?.variantSku,
          };
        }

        const dummy = new Array(item?.quantity).fill({
          ...item,
          // name: getDataDetail(item, 'detail', 'name', null)?.name,
          name: item?.productName || item?.name,
          discountPrice: checkIsGift(item, item?.discountPrice),
          erpAmount: checkIsGift(item, item?.erpAmount),
          // originalPrice: item?.originalPrice || 0,
          originalPrice: checkIsGift(item, item?.variant?.originalPrice),
          quantity: 1,
          variantText:
            item?.variantText ||
            item?.variant?.attributeValues
              ?.map((item) => getDataDetail(item)?.name)
              ?.join('/') ||
            record?.order?.items?.find((e) => e?.id === item?.id)?.variantText,
          sku: item?.sku || item?.variantSku,
        });
        return dummy;
      }),
    ).map((item: DynamicObjectType, index) => ({
      ...item,
      keyPosition: item?.keyPosition || `${item?.id}-${(index + 1).toString()}`,
    }));
  };

  useEffect(() => {
    if (isEdit && record) {
      if (
        record?.status === RETURN_STATUS['AWAITING_APPROVAL'].value &&
        isLayoutEditProducts
      ) {
        const data = handleConvertData(record?.order?.items);
        setProductsInOrder(data);
      } else {
        const data = handleConvertData(record?.items);
        setProductsInOrder(data || []);
      }
    }
  }, [form, record, isLayoutEditProducts]);

  return (
    <Card className="w-full" title={t('ordersReturn.productInfo')}>
      {!isEdit && (
        <OrderProductSelect
          handleGetProducts={handleGetProducts}
          handleConvertData={handleConvertData}
        />
      )}
      <TableProductSelected
        isLayoutEditProducts={isLayoutEditProducts}
        products={productsInOrder}
        openVariantSelectionModal={openVariantSelectionModal}
      />
    </Card>
  );
}

export default ProductsCard;
